import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ConfigurationProductsComponent } from '../configuration-Products/configuration-Products.component';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.css']
})
export class ComponentEditProductComponent implements ICellRendererAngularComp {
  countryCode: any;
  params: any; z
  isEditVisible: any;
  gridApi: any;
  productid: any;
  projectId: any;
  productArray: any;
  getProductData: () => any[];
  getRowIndex: () => number;
  rowIndex: number;
  configurationData: any;
  EditVisible: any;
  constructor(
    public dialog: MatDialog,
    private localStorageService: LocalStorageService,
  ) { }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  // get called on load of the component;
  agInit(params: any) {
    // debugger;
    // console.log(params);
    this.params = params;
    this.gridApi = params.api;
    console.log(params.data)
    this.getProductData = params.SelectedProductData.getProductData || (() => []);
    this.getRowIndex = params.SelectedProductData.getRowIndex || (() => 0);
    this.isEditVisible = !params.data.IsLock && params.data.ProductTreeVisible
    if (this.params.data.hasOwnProperty("IsEditable")) {
      this.EditVisible = this.params.data.IsEditable;
    }
    if (params.data.Id == 0)
      this.isEditVisible = true;
    this.countryCode = this.localStorageService.get('countryCode');

    this.configurationData = this.localStorageService.get("configuration");
  }

  editData(params: any) {
    // console.log(params.data.Id);
    this.productArray = this.getProductData();
    this.rowIndex = this.getRowIndex();
    // console.log(this.productArray);
    let dialogRef = this.dialog.open(ConfigurationProductsComponent, {
      height: '65%',
      width: '50%',
      panelClass: 'product-dialog-container',
      data: {
        SelectedProductData: this.productArray,
        configurationData: params.data.Id,
        ProdjectId: this.projectId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(result);
      if (result != "" && result != undefined) {
        if (result.UpdatedProductArray && result.UpdatedProductArray.length > 0) {
          this.params.context.onProductDataUpdate(result.UpdatedProductArray, params.data.Id, this.rowIndex);
          // console.log("Sent");
        }
      }
    });
  }

}
